import { render, staticRenderFns } from "./CustomServiceList.vue?vue&type=template&id=785927e6&"
import script from "./CustomServiceList.vue?vue&type=script&lang=js&"
export * from "./CustomServiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports